import { render, staticRenderFns } from "./view-sale-order-request.vue?vue&type=template&id=0f508f44&"
import script from "./view-sale-order-request.vue?vue&type=script&lang=ts&"
export * from "./view-sale-order-request.vue?vue&type=script&lang=ts&"
import style0 from "./view-sale-order-request.vue?vue&type=style&index=0&id=0f508f44&prod&lang=css&"
import style1 from "./view-sale-order-request.vue?vue&type=style&index=1&id=0f508f44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports